var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app-admin-wrap-layout-6",style:({
    background: _vm.$vuetify.theme.themes[_vm.theme].background,
    color: _vm.$vuetify.theme.themes[_vm.theme].color,
  })},[_c('Header'),_c('side-bar'),_c('base-view'),_c('renew-token')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }